export const COMPANY_SIZE = [
  'MAPPING.COMPANY_SIZE.smallest',
  'MAPPING.COMPANY_SIZE.small',
  'MAPPING.COMPANY_SIZE.medium',
  'MAPPING.COMPANY_SIZE.big',
];

export const COMPANY_SIZE_AMOUNT = ['1-9', '10-49', '50-249', '250+'];
